import { API_ENDPOINT } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useHubUser } from "@/hooks/user/useHubUser";
import { useMutation } from "@tanstack/react-query";

export type SubmitCryptoComRefereeRequestPayload = {
  exchangeAccountId: string;
  correlationId: string;
};

export const useSubmitCryptoComRefereeRequest = () => {
  const apiHelper = useApi();
  const { auth } = useHubUser();

  return useMutation({
    mutationFn: async (payload: SubmitCryptoComRefereeRequestPayload) => {
      const { correlationId, exchangeAccountId } = payload;

      return apiHelper.postAuth(auth, API_ENDPOINT.HUB_CRYPTOCOM_REFEREE_SUBMIT, {
        bodyParams: { exchangeAccountId },
        headers: {
          correlationId,
        },
      });
    },
  });
};
